















































































import Vue from 'vue'
import Component from 'vue-class-component'
import RuleEngineRule from '../components/RuleEngineRule.vue'
import CodeEditor from '../components/CodeEditor.vue'
import {
  RuleEngineAlgorithmTrigger,
  RuleEngineFact,
  RuleConditionType,
  RuleEngineOperator,
  RuleEngineEvent,
  RuleEventType,
  RuleEngineRule as IRuleEngineRule,
  RuleEngineAlgorithm,
  AlgorithmType
} from '../utils/types'
import { Action, Getter } from 'vuex-class'
import { Prop, Watch } from 'vue-property-decorator'

@Component({
  components: { RuleEngineRule, CodeEditor }
})
export default class AlgorithmCrud extends Vue {
  @Action createRuleEngineAlgorithm!: (
    payload: RuleEngineAlgorithm
  ) => Promise<boolean>

  @Action fetchBranches!: () => Promise<void>
  @Action fetchRuleEngineBlocks!: () => Promise<void>
  @Getter ruleEngineFacts!: RuleEngineFact[]
  @Getter ruleEngineOperators!: RuleEngineOperator[]
  @Prop(Object) algorithm!: RuleEngineAlgorithm | null
  algorithmCode = ''
  algorithmName = ''
  algorithmSavedMessage = ''
  algorithmType: AlgorithmType = AlgorithmType.RULE_ENGINE

  events: RuleEngineEvent[] = [
    {
      name: 'הודעה למשתמש',
      type: RuleEventType.USER_MESSAGE
    },
    {
      name: 'הגדרת עובדה זמנית',
      type: RuleEventType.ADD_FACT
    },
    {
      name: 'הוספת מידע למשמרת',
      type: RuleEventType.ADD_SHIFT_INFO
    }
  ]

  rules: IRuleEngineRule[] = []
  selectedTrigger: RuleEngineAlgorithmTrigger | null = null

  triggers = [
    {
      text: 'תחילת משמרת',
      value: RuleEngineAlgorithmTrigger.SHIFT_START
    },
    {
      text: 'סוף משמרת',
      value: RuleEngineAlgorithmTrigger.SHIFT_END
    },
    {
      text: 'מחיקת משמרת',
      value: RuleEngineAlgorithmTrigger.SHIFT_DELETE
    },
    {
      text: 'סוף שבוע',
      value: RuleEngineAlgorithmTrigger.WEEK_END
    },
    {
      text: 'סוף חודש',
      value: RuleEngineAlgorithmTrigger.MONTH_END
    },
    {
      text: 'גמר חשבון',
      value: RuleEngineAlgorithmTrigger.WORK_END
    }
  ]

  @Watch('algorithm')
  onAlgorithmPropChange (value: RuleEngineAlgorithm | null) {
    if (!value) {
      this.resetAlgorithmDefinition()
      return
    }
    this.algorithmName = value.name || ''
    this.algorithmCode = value.code || ''
    this.algorithmType = value.isCoded ? AlgorithmType.CODE : AlgorithmType.RULE_ENGINE
    this.selectedTrigger = value.trigger || null
    this.rules = value.rules || []
    if (this.rules.length === 0) {
      this.appendRules()
    }
  }

  appendRules () {
    this.rules.push({
      topCondition: { type: RuleConditionType.FACT },
      eventType: RuleEventType.USER_MESSAGE,
      eventParam: ''
    })
  }

  deleteRule (i: number) {
    this.rules.splice(i, 1)
  }

  async emitSave () {
    if (this.isSaveButtonDisabled) {
      return
    }
    this.$emit('save', {
      name: this.algorithmName,
      trigger: this.selectedTrigger,
      isCoded: this.algorithmType === AlgorithmType.CODE,
      rules: this.rules,
      code: this.algorithmCode
    })
  }

  async mounted () {
    await this.fetchBranches()
    await this.fetchRuleEngineBlocks()
    this.onAlgorithmPropChange(this.algorithm)
  }

  resetAlgorithmDefinition () {
    this.algorithmName = ''
    this.algorithmCode = ''
    this.selectedTrigger = null
    this.rules = []
    this.appendRules()
  }

  get editorGlobals (): string {
    switch (this.selectedTrigger) {
      case RuleEngineAlgorithmTrigger.WORK_END:
        return 'declare const payload: EndJobForm'
      case RuleEngineAlgorithmTrigger.SHIFT_DELETE:
      case RuleEngineAlgorithmTrigger.SHIFT_END:
        return 'declare const payload: Shift'
      default:
        return ''
    }
  }

  get isAlgorithmSavedMessageVisible (): boolean {
    return !!this.algorithmSavedMessage
  }

  set isAlgorithmSavedMessageVisible (value: boolean) {
    if (!value) {
      this.algorithmSavedMessage = ''
    }
  }

  get isSaveButtonDisabled () {
    let isAlgorithmContentValid = !!this.rules?.length
    if (this.algorithmType === AlgorithmType.CODE) {
      isAlgorithmContentValid = !!this.algorithmCode.length
    }
    return !this.algorithmName || !this.selectedTrigger || !isAlgorithmContentValid
  }
}
